import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { AnimatedDashboard } from '../../../components/animation/AnimatedDashboard';
import { getUserTickets } from '../../../slices/auth-slice';
import { H2, H3, P1, P2 } from '../../../styles/FontStyles';
import {
  Box,
  Flexed,
  SectionSeparator
} from '../../../styles/GlobalComponents';
import { color, colors } from '../../../styles/GlobalStyles';
import { getAkashaHubs } from '../Marketplace.actions';

import { USDT, formatUSDNoDecimals } from '../../../helpers/helperFunctions';

import { AkashaGrid, GridItem } from './StarterPackages.styled';

import { Button } from '../../../components/common/Button/Button';
import Spinner from '../../../components/common/Spinner';

import packageDummy from '../../../assets/images/backoffice/litePackegeDummy.png';
import { CheckGreen, Icon } from '../../../styles/Icons';

const packages = [
  {
    benefits: [
      { name: '1 Year Back-Office Subscription 1', value: 450, checked: true },
      { name: '1 Basic Guardian Node (5 year)', value: 450, checked: true },
      {
        name: '1 Month Basic DreamTrips Membership',
        value: 450,
        checked: true
      },
      { name: '1 BitcoinBlack Card', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false }
    ],
    packageId: 1,
    name: 'Lite',
    price: 2000,
    image: packageDummy
  },
  {
    benefits: [
      { name: '1 Year Back-Office Subscription 1', value: 450, checked: true },
      { name: '1 Basic Guardian Node (5 year)', value: 450, checked: true },
      {
        name: '1 Month Basic DreamTrips Membership',
        value: 450,
        checked: true
      },
      { name: '1 BitcoinBlack Card', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false }
    ],
    packageId: 1,
    name: 'Economy',
    price: 20000,
    image: packageDummy
  },
  {
    benefits: [
      { name: '1 Year Back-Office Subscription 1', value: 450, checked: true },
      { name: '1 Basic Guardian Node (5 year)', value: 450, checked: true },
      {
        name: '1 Month Basic DreamTrips Membership',
        value: 450,
        checked: true
      },
      { name: '1 BitcoinBlack Card', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false },
      { name: 'Lorem ipsum donor sit', value: 450, checked: false }
    ],
    packageId: 1,
    name: 'Business',
    price: 200000,
    image: packageDummy
  }
];

export const StarterPackages = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { loading, hubs } = useSelector((state) => state.marketplace);

  const firstHub = [hubs[0]];

  useEffect(() => {
    dispatch(getAkashaHubs());
    dispatch(getUserTickets());
  }, [dispatch]);

  const [selectedHub, setSelectedHub] = useState(hubs?.[0] || null);
  const [modal, setModal] = useState(false);

  const handleSeeDetails = (hub) => {
    setSelectedHub(hub);
  };

  const handleSelectPackage = (hub) => {
    setModal(true);
    handleSeeDetails(hub);
  };

  useEffect(() => {
    setSelectedHub(hubs?.[0]);
  }, [hubs]);

  if (loading) return <Spinner fullScreen={true} />;

  return (
    <AnimatedDashboard zoom key={'marketplace'}>
      <Box dark p='60px 80px'>
        <H3 color={colors.primary900} mb='22'>
          Choose your starter package
        </H3>

        <AkashaGrid>
          {packages.map((hub, index) => (
            <GridItem
              key={index}
              selected={selectedHub?.id === hub?.id}
              onClick={() => handleSeeDetails(hub)}>
              <img src={hub.image} style={{ width: '100%' }} />

              <div>
                <Flexed column center>
                  <H2 color={colors.primary900} mb='4' mt='30'>
                    {hub.name}
                  </H2>
                </Flexed>
                <P1 mb='30' color={colors.primary900}>
                  {formatUSDNoDecimals(hub.price)} {USDT}
                </P1>

                {hub.benefits.map(({ name, value }, i) => {
                  return (
                    <Flexed center between gap='50px' key={i} mb='12'>
                      <Flexed center gap='5px'>
                        <Icon>
                          <CheckGreen />
                        </Icon>
                        <P2 left color={colors.neutral0} key={i}>
                          {name}
                        </P2>
                      </Flexed>
                      <P2
                        style={{ flex: 'none' }}
                        right
                        color={colors.neutral0}
                        key={i}>
                        ${formatUSDNoDecimals(value)}
                      </P2>
                    </Flexed>
                  );
                })}

                <SectionSeparator margin='40px 0' />
              </div>

              <Button
                w='100%'
                wSM='100%'
                onClick={() => handleSelectPackage(hub)}>
                Buy {hub.name} Node
              </Button>
            </GridItem>
          ))}
        </AkashaGrid>

        <Flexed center justifyCenter mt='40'>
          <Button w='300px' wSM='100%' negativeLight>
            Start Without Package
          </Button>
        </Flexed>
      </Box>
    </AnimatedDashboard>
  );
};
